.root {
  min-height: 48px;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border: none;
  border-radius: var(--border-radius-small);
  background: none;
  justify-content: start;
  text-align: start;
  overflow: hidden;
  cursor: pointer;

  &:not(.disabled):hover {
    background-color: var(--color-gray-80);
  }

  &.selected {
    background-color: var(--color-gray-80);
  }

  &.disabled {
    cursor: auto;
  }
}
.disabled {
}
.selected {
}

.icon {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;

  // A saved template's image is SVG markup the template carries, drawn at whatever size its author
  // gave it — without this the row is painted over by a full-size one.
  > svg {
    width: 100%;
    height: 100%;
  }
}

.title {
  min-width: 0;
  color: var(--color-gray-black);
}
